import React from 'react';
import BounceLoader from "react-spinners/BounceLoader";
import {green } from "../../helpers/StyleConstants";
import './Spinner.scss';

type Props = {
    msg?: string | null
    propClass?: string | null
};

const Spinner: React.FC<Props> & { defaultProps: Partial<Props> } = props => {
    return (
        <div className={props.propClass ?? 'spinner active'}>
            <BounceLoader size={60} color={green}/>
            {
                null !== props.msg && '' !== props.msg &&
                <div className="msg">
                    {props.msg}
                </div>
            }

        </div>
    );
};

Spinner.defaultProps = {
    msg: undefined,
    propClass: undefined,
};

export default Spinner;
